import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-introduction-form-answers',
  templateUrl: './introduction-form-answers.component.html',
  styleUrls: ['./introduction-form-answers.component.scss']
})
export class IntroductionFormAnswersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
